<template>
  <div id="app" style="width: 100%; height: 100%;">
    <!-- @touchmove.prevent -->
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive
      :include="[
        'home',
        'transfer',
        'issue',
        'business',
        'mybusiness',
        'autorizeradd',
        'changemanager'
      ]"
    >
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { resCode } from 'api/config'
import { setStorage, getStorage } from 'api/user'
import { getVersion } from 'api/baseapi'
import { Hub } from 'common/js/hub'
export default {
  created () {
    // this.allowBack = getStorage('allowBack')
    const version = getStorage('version') || ''
    if (!version) {
      getVersion().then(res => {
        if (res.code === resCode.ERR_OK) {
          setStorage('version', res.resdata)
        }
      })
    }
  },
  mounted () {
    window.onpopstate = () => {
      if (!Hub.allowBack) {
        history.go(1)
      }
    }
  }
}
</script> 

<style lang="stylus" rel="stylesheet/stylus">
.cube-toast .cube-popup-mask {
  opacity: 0;
}

#coupons .cube-swipe-btn {
  margin-left: 2px;
}

#flexrih {
  div {
    &:after {
      border: none;
    }
  }
}

.flex {
  display: flex;
}

.f-column {
  display: flex;
  flex-direction: column;
}

.f-row {
  display: flex;
  flex-direction: row;
}

.f-c-c {
  display: flex;
  justify-content: center;
  align-items: center;
}

.f-row-c {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.f-column-c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.f-column-c-space {
  display: flex;
  align-content: center
  justify-content: space-between
}
.row-r-g {
  flew-grow: 1
}
.clamp {
  overflow: hidden
  text-overflow: ellipsis
  white-space nowrap
  display: block
}
.f-row-c-space {
  display: flex;
  justify-content: space-between
}
.f-column-sfs {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
}
.f-row-c-s {
  display: flex;
  align-items: center
  justify-content: space-between
}
</style>



// WEBPACK FOOTER //
// src/App.vue